<core-versions-detail-preview-file
    *ngIf="status == STATUS_DONE"
    [version]="version"
    [file]="file"
    [notesAllowedUser]="user"
    [menu]="menu"
    [context]="context"
    [canCreateNotes]="canCreateNotes"
    [notesUrlPrefix]="notesUrlPrefix"
    [annotationsUrlPrefix]="annotationsUrlPrefix"
    [annotationsSaveUrlPrefix]="annotationsSaveUrlPrefix"
    (menuClick)="onMenuClick($event)"
    (actionDownloadClick)="onActionDownloadClick($event)"
></core-versions-detail-preview-file>
